import { render, staticRenderFns } from "./GalleryUploader.vue?vue&type=template&id=bb6d3558"
import script from "./GalleryUploader.vue?vue&type=script&lang=ts"
export * from "./GalleryUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports